import { useContext, useEffect, useState } from "react";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import { useCallApi, useSampleFile, useUploadFile } from "./hook";
import {
    HandleBulkInventoryApiReturn,
    InventoryData,
    PreparedDataReturn,
    TExcelData,
} from "./interface";
import { useToasts } from "react-toast-notifications";
import { HeaderHeading } from "../../../../Context";

const { BulkInventoryAdd } = organisms;

const Index = () => {
    const { setHeader, setSidebar }: any = useContext(HeaderHeading);

    const { handleFileUpload, preparedData, prepareDataForTable } =
        useUploadFile();
    const { handleDownloadSampleFormate } = useSampleFile();
    const { handleBulkInventoryApi, verifyBulkInventory } = useCallApi();

    const { addToast } = useToasts();

    //state to store loading state
    const [isLoading, setIsLoading] = useState<boolean>(false);

    //inventory Table data
    const [inventoryData, setInventoryData] = useState<
        HandleBulkInventoryApiReturn[]
    >([]);

    //formatted Data
    const [formattedData, setFormattedData] = useState<PreparedDataReturn[]>();
    const [errorData, setErrorData] = useState<TExcelData[]>();
    const [] = useState();

    const columns = ["Storecode", "Product ID", "Barcode", "Unitcost", "Remark"];

    const handleSubmit = async () => {
        setIsLoading(true);
        if (formattedData) {
            for (let i = 0; i < formattedData?.length; i++) {
                await handleBulkInventoryApi(formattedData[i]);
            }
            addToast("File Upload successfully", {
                appearance: "success",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
            setIsLoading(false);
        }
    };

    //function to valid of json data
    const verifyData = async (data: PreparedDataReturn[]) => {
        let modifiedData: HandleBulkInventoryApiReturn[] = [];
        for (let i = 0; i < data?.length; i++) {
            const apiData = await verifyBulkInventory(data[i]);
            //handle the case of invalid product Id

            //end
            let data2 = prepareDataForTable(apiData, data[i]);
            modifiedData.push(...data2);
        }
        setInventoryData(modifiedData);
    };
    //end

    //callback function to task after excel data convert into json data
    const handleFileData = (data: TExcelData[]) => {
        let formatData = preparedData(data);
        verifyData(formatData);
        setFormattedData(formatData);
    };

    useEffect(() => {
        setHeader("Bulk Inventory Upload");
        setSidebar(false);
    }, []);

    return (
        <Wrapper>
            <BulkInventoryAdd
                handleFileUpload={(value: any) =>
                    handleFileUpload(value, handleFileData)
                }
                handleDownloadSampleFormate={() =>
                    handleDownloadSampleFormate({
                        columns: columns,
                        fileName: "bulk_inventory_sample_excel",
                    })
                }
                inventoryData={inventoryData}
                // excelData={excelData}
                handleSubmit={() => handleSubmit()}
                isLoading={isLoading}
            />
            {/* loader */}
            {isLoading && (
                <div
                    style={{
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        position: "absolute",
                        alignItems: "center",
                    }}
                    className="loading-One"
                >
                    <div
                        style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            zIndex: "9999",
                        }}
                        className="spinner-border text-primary loading-Two"
                        role="status"
                    >
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </Wrapper>
    );
};

export default Index;
